import { getStaticImage } from 'utils/statics'

/**
 * Get automation icon
 * @param {string} name
 *
 * @returns {string}
 */
export const getAutomationIcon = (name) => {
  switch (name) {
    case 'faq_console':
      return getStaticImage('/chatbot/orange-brand/bot-response.svg')
    case 'operator_assistant':
      return getStaticImage('/chatbot/orange-brand/bot-assistant.svg')
    case 'smartchat':
      return getStaticImage('/chatbot/orange-brand/bot-smarchat.svg')
    case 'chatmail':
      return getStaticImage('/channels/orange-brand/chatmail-icon.svg')
    case 'automation':
      return getStaticImage('/icons/orange-brand/bottie.svg')
    case 'chat_marketing':
      return getStaticImage('/chatbot/orange-brand/bot-smarchat.svg')
    default:
      return getStaticImage('/icons/orange-brand/icon-avatar.svg')
  }
}

/**
 * Get automation tag name
 * @param {string} name
 *
 * @returns {string}
 */
export const getAutomationNameTag = (name) => {
  switch (name) {
    case 'faq_console':
      return 'dashboard_virtual-assistant'
    case 'operator_assistant':
      return 'dashboard_operator_assistant'
    case 'smartchat':
      return 'dashboard_smartchat'
    case 'chatmail':
      return 'ChatMail'
    case 'automation':
      return 'conversations_activities_name_automation'
    case 'chat_marketing':
      return 'Marketing'
    default:
      return ''
  }
}